module.exports = __GETREMOTE__('AUTH');